module.exports = __webpack_public_path__ + "img/chengyun2.a988a499.png";